import React, { useCallback, useState } from "react";
import { CompactPicker } from "react-color";
import { observer } from "mobx-react-lite";

import useModel from "../model/Model";

const ColorSelector = ({ inputColor }) => {
    const model = useModel();
    const [color, setColor] = useState(inputColor);

    const handleColorChange = useCallback((color) => {
        setColor(color.hex);
    }, []);

    return (
        <div id="ColorSelector">
            <CompactPicker color={color} onChangeComplete={handleColorChange} />
            <div>
                <button onClick={model.savePolygonChangeColor.bind(model, color)}>Save</button>
                <button onClick={model.cancelPolygonChangeColor.bind(model)}>Cancel</button>
            </div>
        </div>
    );
};

export default observer(ColorSelector);
